export default __webpack_public_path__ + "static/media/pCRO.1f0f774b.svg";